<template>
	<div class="page flex-l">
		<!-- 头部导航栏 -->
		<!-- 占位且字体黑色 -->
		<head-bar
			v-if="['News', 'DownLoad', 'Dynamic', 'Form'].indexOf(path) != -1"
			:shadow="['DownLoad', 'Form', 'News'].indexOf(path) != -1"
			:hint="true"
			color="black"
		></head-bar>
		<!-- 不占位且字体白色 -->
		<head-bar v-else></head-bar>

		<!-- 路由 -->
		<div class="flex1"><router-view></router-view></div>

		<!-- 悬浮按钮 -->
		<div class="fiex-btn-box" :class="{ 'fiex-btn-box-show': $store.state.scroll_height > 20 }">
			<div class="fiex-btn"><img src="@/assets/img/message.png" @click="$router.push({ name: 'Form' })" /></div>
			<div class="fiex-btn" @click="toTop">
				<img
					src="https://imgtest.togy.com.cn/oyjj/langGuo/footer/top1.png"
					onmouseenter="this.src = 'https://imgtest.togy.com.cn/oyjj/langGuo/footer/top2.png'"
					onmouseleave="this.src = 'https://imgtest.togy.com.cn/oyjj/langGuo/footer/top1.png'"
				/>
			</div>
		</div>

		<!-- 底部栏 -->
		<div style="background-color: #F6F6F6;">
			<div class="content pt-40">
				<!-- 手机 -->
				<div v-if="is_phone" class="flex-lcs pb-30" style="border-bottom: 2px solid #BEBEBE;">
					<img class="dis-b ptb-20" style="width: 1.6rem;height: auto;" :src="icon_info.logo" />
					<div class="fs-14 ptb-20" style="color: #000000;">{{ icon_info.signTile }}</div>
				</div>
				<!-- PC -->
				<div v-else class="flex-c pb-45" style="border-bottom: 2px solid #BEBEBE;">
					<div class="flex1">
						<img class="dis-b" style="width: 1.6rem;height: auto;" :src="icon_info.logo" />
						<div class="fs-14 pt-20" style="color: #000000;">{{ icon_info.signTile }}</div>
					</div>
					<span class="fs-16 mr-15">{{$store.state.language == 'EN' ? 'follow us':'关注我们'}}</span>
					<!-- type  1链接，2二维码 -->
					<div class="foucs-on-us" v-for="(v, i) in icon_info.list" :key="i" @mouseenter="icon_index = i" @mouseout="icon_index = -1">
						<img class="qr-code" v-if="icon_index == i && v.type == 2" :src="icon_info.list[icon_index].qr_code" />
						<a :href="v.link" v-if="v.type == 1"><img class="foucs-icon" :src="icon_index == i ? v.img2 : v.img" /></a>
						<img class="foucs-icon" v-else :src="icon_index == i ? v.img2 : v.img" />
					</div>
				</div>
				<!-- 链接列表 -->
				<!-- <div class="mt-45 over-hi" v-if="is_phone">
					<span class="pr-15 mr-15 fs-12 fw" style="border-right: 1px solid rgba(50,50,50,.3);line-height: 28px;" v-for="(v, i) in footer_list" :key="i">{{ v.title }}</span>
				</div> -->
				<div  v-if="is_phone">
					<div class="pr-15 mr-15 fs-12 mb-30" v-for="(v, i) in footer_list" :key="i">
						<div class="h2 pt-20 pb-10 fs-w">{{ v.title }}</div>
						<div class="flex-w h5">
							<a class="ptb-10" style="width: 50%;" v-for="(val, ind) in v.childrenList" :key="ind" :href="val.url" target="_blank">{{ val.title }}</a>
						</div>
					</div>
				</div>
				<div class="mt-45 flex over-hi" style="justify-content: space-between;" v-else>
					<div class="" style="display: inline-block;" v-for="(v, i) in footer_list" :key="i">
						<div class="fs-16 fw mb-20">{{ v.title }}</div>
						<a class="footer-item lh-24" v-for="(val, ind) in v.childrenList" :key="ind" :href="val.url" target="_blank">{{ val.title }}</a>
					</div>
				</div>
			</div>
			<div class="flex-cs mt-50" style="min-height: 0.61rem;background-color: #000000;">
				<div class="fs-14 co-bc pr-45">
					<a href="http://beian.miit.gov.cn" target="_blank">粤ICP备14024048号</a>
				</div>
				<!-- <div class="fs-14 co-bc pr-45">©2020 lango-tech.com. All Rights Reserved. Design by mfweb.</div>
				<div class="fs-14 co-bc">{{$store.state.language == 'EN' ? 'Website statement | Privacy policy':'网站声明丨隐私政策'}}</div> -->
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Home',
	data() {
		return {
			icon_info: {},
			icon_index: -1,
			footer_list: []
		};
	},
	created() {
		this.$debug && console.log('路由', this.$route);

		// 获取底部链接
		this.$get({
			url: 'app/getMenus',
			success: res => {
				this.footer_list = res.list;
			}
		});

		// 分享二维码参数及logo
		this.$get({
			url: 'app/getShare',
			success: res => {
				this.icon_info = res;
			}
		});
	},
	computed: {},
	methods: {
		// 回到顶部
		toTop() {
			// scrollTo(0,0);
			this.scroll({ scroll: 0 });
			return;
			let distanceY = window.pageYOffset;
			let step = distanceY / 50; //所用时长等于50*定时器的时长
			let tiemr = setInterval(() => {
				distanceY -= step;
				if (distanceY <= 0) {
					clearInterval(tiemr);
					distanceY = 0;
				}
				window.scrollTo(0, distanceY);
			}, 10);
		}
	}
};
</script>
<style scoped="scoped">
.qr-code {
	position: absolute;
	transform: translate(-50%, -120%);
	left: 50%;
	width: 0.98rem;
	height: 0.98rem;
}
.foucs-icon {
	width: 30px;
	height: 30px;
}
.foucs-on-us {
	font-size: 0.16rem;
	position: relative;
	cursor: pointer;
	margin: 0.2rem 0 0.2rem 0.3rem;
}
/* 底部栏 */
.footer-item {
	font-size: 0.14rem;
	color: #a7a6a6;
	padding: 0.1rem 0;
	cursor: pointer;
	display: block;
}

.footer-item:hover {
	color: #434343;
	font-weight: bold;
}

/* 悬浮按钮 */
.fiex-btn-box {
	padding: 0.3rem;
	position: fixed;
	bottom: 0rem;
	right: -1rem;
	opacity: 0;
	transition: all 0.3s;
}
.fiex-btn-box-show {
	opacity: 1;
	right: 0rem;
}
.fiex-btn {
	width: 45px;
	height: 45px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background: #e6e6e6;
	cursor: pointer;
}
.fiex-btn>img{
	width: 70%;
	height: 70%;
}
.fiex-btn:nth-child(1) {
	background-color: #ffffff;
	margin-bottom: 0.2rem;
	box-shadow: 0px 0px 0.1rem 0px rgba(0, 0, 0, 0.16);
}
.fiex-btn:nth-child(2):active {
	box-shadow: 0px 0px 0.1rem 0px rgba(0, 0, 0, 0.16);
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue